module.exports = __webpack_public_path__ + "img/home-background.b5a55096.png";